module.exports = __webpack_public_path__ + "static/media/53.54eacaf.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/53.wav
// module id = Heby
// module chunks = 0